if (!customElements.get('legion-product-tabs')) {
  customElements.define('legion-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.splitDescription();
      this.panels = Array.from(this.querySelectorAll('.lg-product-tab'));
      this.nav = this.querySelector('.lg-product-tabs-nav');
      this.selected = 0;
      this.buttons = this.panels.map((panel, index) => {
        const summary = panel.querySelector('summary');
        const content = panel.querySelector('.lg-product-tab-content');
        const button = document.createElement('button');
        button.type = 'button';
        button.id = 'LegionTab-' + this.dataset.section + '-' + index;
        content.id = 'LegionPanel-' + this.dataset.section + '-' + index;
        button.textContent = summary.textContent;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', content.id);
        button.addEventListener('click', () => this.select(index));
        button.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.panels.length;
          else if (event.key === 'ArrowLeft') next = (index + this.panels.length - 1) % this.panels.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.panels.length - 1;
          else return;
          event.preventDefault();
          this.select(next);
          this.buttons[next].focus();
        });
        this.nav.append(button);
        return button;
      });
      this.media = window.matchMedia('(min-width: 750px)');
      this.onModeChange = () => this.setMode();
      this.media.addEventListener('change', this.onModeChange);
      this.nav.hidden = false;
      this.setMode();
    }
    disconnectedCallback() {
      if (this.media) this.media.removeEventListener('change', this.onModeChange);
      this.initialized = false;
      if (this.nav) this.nav.replaceChildren();
    }
    category(text) {
      const label = text.toLowerCase().replace(/ /g, ' ').trim().replace(/[：:]+$/, '').trim().replace(/\s+/g, ' ');
      if (/^(ingredients?( list)?|ingredients?\s*(?:[&/]|and)\s*nutrition|nutrition(?:al)? (information|facts|values)|nutrition(al)?|supplement facts|allergens?( information)?|allergy (information|advice))$/.test(label)) return 'ingredients';
      if (/^(directions?( for use)?|usage( instructions)?|how to (use|take)|recommended (use|dosage)|dosage|suggested use|serving (instructions|suggestion)|care( instructions)?)$/.test(label)) return 'directions';
      if (/^(warnings?( and precautions)?|precautions?|cautions?|storage( instructions)?|warnings?\s*[&/]\s*storage|safety( information)?|important( information)?|please note|disclaimer)$/.test(label)) return 'warnings';
      if (/^(overview|description|product (details|information|overview)|key (features|benefits)|features|benefits|size guide)$/.test(label) || /^about\b/.test(label)) return 'overview';
      return null;
    }
    splitDescription() {
      const source = this.querySelector('[data-description]');
      if (!source) return;
      const normalize = text => text.replace(/\s+/g, ' ').trim();
      const candidates = new Map();
      source.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div,strong,b').forEach(element => {
        if (element.closest('table,li')) return;
        let category = this.category(element.textContent);
        let boundary = element;
        if (!category && /^(P|DIV)$/.test(element.tagName)) {
          const first = element.firstElementChild;
          if (first && /^(STRONG|B)$/.test(first.tagName) && !Array.from(element.childNodes).slice(0, Array.from(element.childNodes).indexOf(first)).some(node => normalize(node.textContent))) {
            const firstCategory = this.category(first.textContent);
            if (firstCategory === 'warnings') category = firstCategory;
          }
        }
        if (!category) return;
        while (boundary.parentElement !== source && normalize(boundary.parentElement.textContent) === normalize(boundary.textContent)) boundary = boundary.parentElement;
        candidates.set(boundary, category);
      });
      const boundaries = Array.from(candidates.keys()).filter(element => !Array.from(candidates.keys()).some(parent => parent !== element && parent.contains(element)));
      if (!boundaries.length) return;
      boundaries.sort((a, b) => a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
      const buckets = new Map(['overview', 'ingredients', 'directions', 'warnings'].map(key => [key, document.createDocumentFragment()]));
      const pieces = [];
      let category = 'overview';
      let previous = null;
      [...boundaries, null].forEach(boundary => {
        const range = document.createRange();
        if (previous) range.setStartBefore(previous);
        else range.setStart(source, 0);
        if (boundary) range.setEndBefore(boundary);
        else range.setEnd(source, source.childNodes.length);
        const piece = range.cloneContents();
        pieces.push(piece.textContent);
        buckets.get(category).append(piece);
        if (boundary) category = candidates.get(boundary);
        previous = boundary;
      });
      if (normalize(pieces.join('')) !== normalize(source.textContent)) return;
      const mediaSources = container => Array.from(container.querySelectorAll('img,video,iframe,source,a')).map(element => element.tagName + ':' + (element.getAttribute('src') || element.getAttribute('href'))).sort().join('|');
      const combined = document.createElement('div');
      buckets.forEach(fragment => combined.append(fragment.cloneNode(true)));
      if (mediaSources(combined) !== mediaSources(source)) return;
      const replacement = document.createDocumentFragment();
      buckets.forEach((fragment, key) => {
        if (!normalize(fragment.textContent) && !fragment.querySelector('img,table,video,iframe')) return;
        const details = document.createElement('details');
        details.className = 'lg-product-tab';
        details.dataset.category = key;
        details.open = !replacement.childNodes.length;
        const summary = document.createElement('summary');
        summary.textContent = this.dataset[key];
        const content = document.createElement('div');
        content.className = 'lg-product-tab-content rte';
        content.append(fragment);
        details.append(summary, content);
        replacement.append(details);
      });
      if (replacement.childNodes.length) source.closest('details').replaceWith(replacement);
    }
    select(index) {
      this.selected = index;
      this.panels.forEach((panel, i) => {
        panel.open = i === index;
        this.buttons[i].setAttribute('aria-selected', String(i === index));
        this.buttons[i].tabIndex = i === index ? 0 : -1;
      });
    }
    setMode() {
      const desktop = this.media.matches;
      this.dataset.desktop = String(desktop);
      this.nav.setAttribute('aria-hidden', String(!desktop));
      this.panels.forEach((panel, index) => {
        const content = panel.querySelector('.lg-product-tab-content');
        if (desktop) {
          content.setAttribute('role', 'tabpanel');
          content.setAttribute('aria-labelledby', this.buttons[index].id);
          content.tabIndex = 0;
        } else {
          content.removeAttribute('role');
          content.removeAttribute('aria-labelledby');
          content.removeAttribute('tabindex');
          panel.open = false;
        }
      });
      if (desktop) this.select(this.selected);
    }
  });
}

